import Component from './Action.vue';

export default {
  install(Vue) {
    Vue.component('BkfAction', Component);
  },
};
